import { useContext, useState } from "react";
import { BasicListContext } from "../../contexts/BasicListContext";
import FormTitle from "../../components/helpers/FormTitle";
import { Box, Button, FormGroup, TextField, Typography } from "@mui/material";
import FactoryIcon from "@mui/icons-material/Factory";
import SourceList from "../../components/administation/sources/SourceList";
import AddHomeIcon from "@mui/icons-material/AddHome";
import BasicRadioGroup from "../../components/form/BasicRadioGoup";
import { _ACTIVE_RADIO_GROUP } from "../../utils/constants";
import { Delete, DeleteOutline } from "@mui/icons-material";

export const SourceAdmin = () => {
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const { extraQueryParams, setExtraQueryParams } =
    useContext(BasicListContext);

  return (
    <>
      <FormTitle title="Manage Sources" />
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}
      >
        <Box
          width={"100%"}
          display={"flex"}
          gap={1}
          alignItems={"baseline"}
          sx={{
            borderBottom: "1px solid #ccc",
          }}
        >
          <FactoryIcon />
          <Typography variant="h6" component="div">
            Sources List
          </Typography>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <TextField
              id="outlined-basic"
              label="Find"
              variant="outlined"
              size="small"
              name="customFind"
              onBlur={(e) => {
                setExtraQueryParams({
                  ...extraQueryParams,
                  name: e.target.value ? e.target.value : null,
                });
              }}
            />
            <FormGroup
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                marginLeft: 2,
              }}
            >
              <BasicRadioGroup
                setExtraQueryParams={setExtraQueryParams}
                extraQueryParams={extraQueryParams}
                choices={_ACTIVE_RADIO_GROUP}
                defaultValue={extraQueryParams?.active}
                onChange={(e) => {
                  setExtraQueryParams({
                    ...extraQueryParams,
                    active: e.target.value,
                  });
                }}
              />
            </FormGroup>
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              title={"New Source"}
              startIcon={<AddHomeIcon />}
              color="success"
              onClick={() => {
                // Modal create source
                setEditData(null);
                setShowModal(true);
              }}
            >
              {"New Source"}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          width: "100%",
        }}
      >
        <SourceList
          editData={editData}
          setEditData={setEditData}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      </Box>
    </>
  );
};

export default SourceAdmin;
